import React from 'react';
import {brand} from '../../brand';

export const PhoneFrame: React.FC<{
  width?: number;
  height?: number;
  children: React.ReactNode;
}> = ({width = 620, height = 1280, children}) => (
  <div
    style={{
      width,
      height,
      borderRadius: 84,
      background: '#0a0a0a',
      border: '8px solid #1c1c1c',
      boxShadow: `0 40px 100px rgba(0,0,0,0.7), 0 0 80px ${brand.primary}33`,
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <div
      style={{
        position: 'absolute',
        top: 22,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 130,
        height: 36,
        borderRadius: 999,
        background: '#000',
        zIndex: 10,
      }}
    />
    <div
      style={{
        position: 'absolute',
        inset: 8,
        borderRadius: 76,
        overflow: 'hidden',
        background: brand.bg,
      }}
    >
      {children}
    </div>
  </div>
);
